import React, { useEffect, useState } from "react";
import "./enterprise.css";
import close from '../../img/close_popup.svg'

const Enterprise = () => {
  const [showPopup, setShowPopup] = useState(false);
  const [sawPopup, setSawPopup] = useState(false);

  const onScroll = (e) => {
    const target = document.querySelector('#enterprise');
    let targetPosition;
    let windowPosition;
    function setPositions() {
      targetPosition = {
        top: window.pageYOffset + target.getBoundingClientRect().top,
        left: window.pageXOffset + target.getBoundingClientRect().left,
        right: window.pageXOffset + target.getBoundingClientRect().right,
        bottom: window.pageYOffset + target.getBoundingClientRect().bottom
      };

      windowPosition = {
        top: window.pageYOffset,
        left: window.pageXOffset,
        right: window.pageXOffset + document.documentElement.clientWidth,
        bottom: window.pageYOffset + document.documentElement.clientHeight
      };
    }

    setPositions();

    if (targetPosition.bottom > windowPosition.top && // Если позиция нижней части элемента больше позиции верхней чайти окна, то элемент виден сверху
      targetPosition.top < windowPosition.bottom && // Если позиция верхней части элемента меньше позиции нижней чайти окна, то элемент виден снизу
      targetPosition.right > windowPosition.left && // Если позиция правой стороны элемента больше позиции левой части окна, то элемент виден слева
      targetPosition.left < windowPosition.right) { // Если позиция левой стороны элемента меньше позиции правой чайти окна, то элемент виден справа
      setTimeout(() => {
        setPositions();
        if (targetPosition.bottom > windowPosition.top && // Если позиция нижней части элемента больше позиции верхней чайти окна, то элемент виден сверху
          targetPosition.top < windowPosition.bottom && // Если позиция верхней части элемента меньше позиции нижней чайти окна, то элемент виден снизу
          targetPosition.right > windowPosition.left && // Если позиция правой стороны элемента больше позиции левой части окна, то элемент виден слева
          targetPosition.left < windowPosition.right) { // Если позиция левой стороны элемента меньше позиции правой чайти окна, то элемент виден справа
          setShowPopup(true);
          window.removeEventListener('scroll', onScroll, false);
        }
      }, 5000)
    }
  };

  useEffect(() => {
    window.addEventListener('scroll', onScroll);
  }, [])

  return (
    <div className="enterprise" id="enterprise">
      <iframe className='iframe_enterprise'
        src="https://geekle.us/version-test/0e_python2/event=python"
        width="100%"
        height="424"
        align="center"
        title='enterprise_frame'
      >
        Ваш браузер не поддерживает плавающие фреймы!
      </iframe>
      {showPopup === true && sawPopup === false &&
        <div className='popup'>
          <div className='popup_container popup_container--left'>
            <h4 className='popup_title'>For Enterprise clients, we offer special prices:</h4>
            <p className='popup_abstract popup_abstract--left popup_abstract--mb'>Groups of 5-10 the discount is 10%</p>
            <p className='popup_abstract popup_abstract--left popup_abstract--mb'>10-15 - 15%</p>
            <p className='popup_abstract popup_abstract--left popup_abstract--mb'>16-20 - 20%</p>
            <p className='popup_abstract popup_abstract--left'>21 and more - 25%</p>
            <img className='popup_close' onClick={() => setSawPopup(true)} src={close} alt="" />
            <a className="button popup_btn--mt" href='https://tawk.to/chat/62d53950b0d10b6f3e7ce13c/1g88efon4' target="_blank" rel='norefferer'>contact us</a>
          </div>
        </div>}
    </div>
  );
};
export default Enterprise;
